import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RoleModel } from '../../_models/role.model';
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services/index';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-updateemployee',
  templateUrl: './updateemployee.component.html',
  styleUrls: ['./updateemployee.component.css']
})
export class UpdateemployeeComponent implements OnInit {

  
  @Input('loading') loading = false;
  @Input('employee') employee :any;
  @Input('isedit') isedit = false;
  @Input('roles') roles: RoleModel[];
  @Output() saveTheEmployee = new EventEmitter();
  public currentUser: any;
  branches: any;
  has_branches: any;
  branch_id: any;
  employee_role = '';
  constructor(public toastr: ToastrService, public operationsService: OperationsService,
    public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.has_branches = storageService.read<any>('has_branches'); 
  }

  ngOnInit() {
   this.getBranches();
    if (!this.isedit) {
      this.employee.EMAIL = "";
      this.employee.LEGAL_NAME = '';
      this.employee.PEOPLE_PEOPLE_ID = '';
    }
    if(this.isedit){
      this.employee_role = this.employee.ROLES[0]
    }
    //console.log(this.roles)
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  getBranches() {
    this.operationsService.getLenderBranches(this.currentUser.token)
      .subscribe(data => {
        if (data.status == true) {
          this.branches = data.data.branches;
        }
      });
  }
  saveEmployee(value) {
    console.log(value)
    // this.saveTheEmployee.emit()
    this.loading = true;
    this.operationsService.saveEmployeeOmni(this.currentUser.token, this.employee, this.employee, this.isedit, this.roles, this.branch_id,value.employee_role)
      .subscribe(status => {
        this.loading = false;

        if (status.status) {
          this.showSuccess(status.message);
          this.employee = status.employee;
        } else {
          this.showError(status.message);
        }
        this.saveTheEmployee.emit();
      });
  }

  checkSector(sector, event, index) {
    if (event == false) {
      this.roles[index].CHECKED_ = event;
    } else {
      this.roles[index].CHECKED_ = event;
    }

  }
  IsAvailable(PEOPLE_PEOPLE_ROLE_ID, index) {
    if (this.isedit == true) {
      if (this.employee.ROLES.indexOf(PEOPLE_PEOPLE_ROLE_ID) != -1) {
        this.roles[index]["CHECKED"] = true;
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }
}

